import api from '../../../api';

// Send invoice email to client (optionally with attachment handled by backend)
export const sendInvoiceEmail = async (emailData) => {
  try {
    const response = await api.post('/crm/invoices/send-email', emailData);
    return response.data;
  } catch (error) {
    console.error('Error sending invoice email:', error);
    throw error;
  }
};

// Get invoice email templates (by templateId 'invoice')
export const getInvoiceEmailTemplates = async () => {
  try {
    const response = await api.get('/email/templates/template-id/invoice');

    let templates = [];
    if (response.data) {
      if (Array.isArray(response.data)) {
        templates = response.data;
      } else if (response.data.content && Array.isArray(response.data.content)) {
        templates = response.data.content;
      } else if (typeof response.data === 'object') {
        templates = [response.data];
      }
    }
    return templates;
  } catch (error) {
    console.error('Error fetching invoice email templates:', error);
    return [];
  }
};

// Check email settings (shared endpoint)
export const getEmailSettings = async () => {
  try {
    const response = await api.get('/email/settings');
    return response.data;
  } catch (error) {
    console.error('Error loading email settings:', error);
    return null;
  }
};

// Get invoice client email resolved from company/contact
export const getInvoiceClientEmail = async (invoiceId) => {
  try {
    const response = await api.get(`/crm/invoices/${invoiceId}/client-email`);
    // Expected shape: { email: string }
    console.log('Invoice client email:', response.data);
    return response.data?.email || '';
  } catch (error) {
    console.error('Error fetching invoice client email:', error);
    return '';
  }
};

// Mark invoice status as SENT_TO_CLIENT
export const markInvoiceSentToClient = async (invoiceId) => {
  try {
    const response = await api.post(`/crm/invoices/${invoiceId}/mark-sent`);
    return response.data;
  } catch (error) {
    console.error('Error marking invoice as SENT_TO_CLIENT:', error);
    throw error;
  }
};


